import React, { useState, useEffect } from "react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const [accepted, setAccepted] = useState(null);

  useEffect(() => {
    // Check if user already gave consent
    const consent = localStorage.getItem("adika_cookie_consent");
    if (consent) {
      setAccepted(JSON.parse(consent));
      setShow(false);
    } else {
      // First visit - show banner
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    const consentData = { accepted: true, date: new Date().toISOString() };
    localStorage.setItem("adika_cookie_consent", JSON.stringify(consentData));
    setAccepted(true);
    setShow(false);
    // Load GA4 without reload
    const id = process.env.REACT_APP_GA4_ID;
    if (id) {
      // Use requestIdleCallback to load GA4 in browser idle time
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => loadGA4(id), { timeout: 2000 });
      } else {
        setTimeout(() => loadGA4(id), 500);
      }
    }
  };

  const loadGA4 = (id) => {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", id);
  };

  const handleReject = () => {
    const consentData = { accepted: false, date: new Date().toISOString() };
    localStorage.setItem("adika_cookie_consent", JSON.stringify(consentData));
    setAccepted(false);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-700">
              This website uses{" "}
              <a
                href="/cookie-policy"
                className="underline font-semibold text-gray-900 hover:text-gray-600"
              >
                cookies and analytics
              </a>{" "}
              to understand how you use our site. By continuing, you accept our use of cookies.
            </p>
          </div>

          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap"
            >
              Reject
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
